import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/** The in-view workspace filter. Empty = all accessible workspaces (the aggregate view). */
interface WorkspaceState {
  selectedIds: string[];
  setSelectedIds: (ids: string[]) => void;
  clear: () => void;
}

export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      selectedIds: [],
      setSelectedIds: (selectedIds) => set({ selectedIds }),
      clear: () => set({ selectedIds: [] }),
    }),
    { name: 'metaxi-workspaces' },
  ),
);

export function selectedWorkspaceParam(): string | undefined {
  const ids = useWorkspaceStore.getState().selectedIds;
  return ids.length ? ids.join(',') : undefined;
}

export function selectedWorkspaceId(): string | undefined {
  const ids = useWorkspaceStore.getState().selectedIds;
  return ids.length === 1 ? ids[0] : undefined;
}
